import React, { useEffect } from 'react';
import { App } from 'antd';
import { useFormik } from 'formik';

import { ShopValues } from '../service/shop.interface';
import { createFormData } from '../../../../../utils/common/createFormData';
import { useUpdateShopMutation } from '../service/shops';
import { SAVE } from '../../../../../shared/contants/actions';
import { ShopForm } from '../components/ShopForm';
import { selectShopCurrent } from '../store/shopSlice';
import { useAppSelector } from '../../../../../store';
import { GenericModal } from '../../../../../shared/ui/GenericModal';
import { validationSchema } from '../utils/fields';
import { useFeed } from '../../feed/hooks/useFeed';

export const ShopEditContainer = ({ open, setOpen }) => {
    const { notification } = App.useApp();

    const current = useAppSelector(selectShopCurrent);
    const { data } = useFeed();

    const [updateShop, { isSuccess, isLoading }] = useUpdateShopMutation();

    const onSave = async (values: ShopValues) => {
        const payload = {
            ...values,
            id: current.id,
            name: values.name,
            about: values.about,
            buyable: values.buyable,
            photo: values.photo,
            price_from: values.price_from,
            photo_url: values.photo_url,
        };
        if (values.photo_url === undefined) {
            delete payload.photo_url;
        }
        if (!(values.photo instanceof File)) {
            delete payload.photo;
        }
        if (values.about === null) {
            delete payload.about;
        }

        await updateShop({ id: current.id, body: createFormData(payload) });
    };

    useEffect(() => {
        if (isSuccess) {
            notification.success({
                message: 'Магазин успешно изменен',
            });
            setOpen(false);
        }
    }, [isSuccess]);

    const mergedValues = (shopValues, feedValues) => {
        return {
            ...feedValues,
            ...shopValues,
        };
    };

    const formik = useFormik({
        initialValues: mergedValues(current, data),
        validationSchema,
        onSubmit: onSave,
        validateOnChange: true,
        validateOnBlur: true,
        validateOnMount: true,
        enableReinitialize: true,
    });

    if (!current) {
        return null;
    }

    return (
        <GenericModal
            open={open}
            destroyOnClose
            title={'Редактировать магазин'}
            okText={SAVE}
            okButtonProps={{
                disabled: isLoading,
                loading: isLoading,
            }}
            onCancel={() => {
                setOpen(false);
            }}
            onConfirm={() => onSave(formik.values)}
        >
            <ShopForm
                disabledFields={[
                    'type',
                    'client_id',
                    'api_key',
                    'create_type',
                    'feed_url',
                ]}
                formik={formik}
            />
        </GenericModal>
    );
};
